import CmDeliveryNoteNumber from './CmDeliveryNoteNumber.vue';
import Comment from './Comment';
import Created from './Created';
import CreatorUser from './CreatorUser';
import Currency from './Currency';
import Customer from './Customer';
import CustomerAddress from './CustomerAddress';
import CustomerCity from './CustomerCity';
import CustomerCountry from './CustomerCountry';
import CustomerCounty from './CustomerCounty';
import CustomerOrder from './CustomerOrder';
import CustomerZip from './CustomerZip';
import DeliveryDate from './DeliveryDate';
import Desadv from './Desadv';
import GrossPrice from './GrossPrice';
import Id from './Id';
import Invoice from './Invoice';
import IsBillable from './IsBillable';
import NetPrice from './NetPrice';
import OrderNumbers from './OrderNumbers';
import ReceiptNumber from './ReceiptNumber';
import Status from './Status';
import Storage from './Storage';
import Stowage from './Stowage';
import Supplier from './Supplier';
import Updated from './Updated';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  CmDeliveryNoteNumber: 'CM szlev szám',
  Status: 'Státusz',
  Supplier: 'Eladó',
  Storage: 'Raktár',
  CreatorUser: 'Rögzítette',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  Comment: 'Megjegyzés',
  Currency: 'Deviza',
  Customer: 'Vevő',
  CustomerAddress: 'Cím',
  CustomerCity: 'Város',
  CustomerCountry: 'Ország',
  CustomerCounty: 'Megye',
  CustomerOrder: 'Vevői megrendelés',
  CustomerZip: 'Irányítószám',
  DeliveryDate: 'Szállítás dátuma',
  Invoice: 'Számla',
  IsBillable: 'Számlázandó',
  OrderNumbers: 'Rendelés számok',
  Stowage: 'Rakodási lista',
  Desadv: 'DESADV',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Storage',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}, {
  value: 'Comment',
}, {
  value: 'Currency',
}, {
  value: 'CustomerAddress',
}, {
  value: 'Customer',
}, {
  value: 'CustomerCity',
}, {
  value: 'CustomerCountry',
}, {
  value: 'CustomerCounty',
}, {
  value: 'CustomerOrder',
}, {
  value: 'CustomerZip',
}, {
  value: 'DeliveryDate',
}, {
  value: 'Invoice',
}, {
  value: 'IsBillable',
}, {
  value: 'OrderNumbers',
}, {
  value: 'Stowage',
}, {
  value: 'Desadv',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Status',
}, {
  value: 'Supplier',
}, {
  value: 'Storage',
}, {
  value: 'CreatorUser',
}, {
  value: 'Customer',
}, {
  value: 'NetPrice',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  CmDeliveryNoteNumber,
  Status,
  Supplier,
  Storage,
  CreatorUser,
  NetPrice,
  GrossPrice,
  Comment,
  Currency,
  Customer,
  CustomerAddress,
  CustomerCity,
  CustomerCountry,
  CustomerCounty,
  CustomerOrder,
  CustomerZip,
  DeliveryDate,
  Invoice,
  IsBillable,
  OrderNumbers,
  Stowage,
  Desadv,
  Created,
  Updated,
};
